import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TemplateApiModel } from '@app/api/api-models/templates/TemplateApiModel';
import { MoveApiModel } from '@app/api/api-models/MoveApiModel';
import { TemplateBaseApiModel } from '@app/api/api-models/templates/TemplateBaseApiModel';
import { TemplateContentApiModel } from '@app/api/api-models/templates/TemplateContentApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { sanitizeHtml } from '@shared/utils/editor-utils';

@Injectable()
export class TemplatesService {
  public apiUrl = 'templates';
  public resetEmitter = new EventEmitter<void>();

  constructor(private readonly http: HttpClientService) {}

  public get(): Observable<TemplateBaseApiModel[]> {
    return this.http.get<TemplateBaseApiModel[]>(`${this.apiUrl}/get-list`);
  }

  public getContent(id: number): Observable<TemplateContentApiModel> {
    return this.http.get<TemplateContentApiModel>(`${this.apiUrl}/${id}/content`);
  }

  public add(template: TemplateApiModel): Observable<TemplateApiModel> {
    template.Description = sanitizeHtml(template.Description);
    return this.http
      .post<TemplateApiModel>(`${this.apiUrl}/add`, template)
      .pipe(tap((_response) => this.resetEmitter.emit()));
  }

  public update(template: TemplateApiModel): Observable<TemplateApiModel> {
    template.Description = sanitizeHtml(template.Description);
    return this.http
      .put<TemplateApiModel>(`${this.apiUrl}/update`, template)
      .pipe(tap((_response) => this.resetEmitter.emit()));
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`).pipe(tap((_response) => this.resetEmitter.emit()));
  }

  public move(moveModel: MoveApiModel<number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, moveModel).pipe(tap((_response) => this.resetEmitter.emit()));
  }
}
